import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
import AppMenuDropdown from './AppMenuDropdown';
import AppMenuContent from './AppMenuContent';
const AppMenu = (props) => {
    const { label = 'Unknown', appMenuItems = [], appNavigatorClassName, appNavigator, onToggleAppMenu } = props, remainingProps = __rest(props, ["label", "appMenuItems", "appNavigatorClassName", "appNavigator", "onToggleAppMenu"]);
    const hasItems = !!((appMenuItems === null || appMenuItems === void 0 ? void 0 : appMenuItems.length) || appNavigator);
    const wrapperClassNames = classNames('ModuleNavigation AppMenu', 'user-select-none', { hasModules: hasItems }, !appNavigator && 'pointer-events-none', appNavigatorClassName && appNavigatorClassName);
    return (_jsx("ul", Object.assign({}, remainingProps, { className: wrapperClassNames }, { children: _jsx(AppMenuDropdown, Object.assign({ title: label, caret: hasItems, onToggleAppMenu: onToggleAppMenu }, { children: appNavigator && _jsx(AppMenuContent, { appMenuItems: appMenuItems, appNavigator: appNavigator }) })) })));
};
export default AppMenu;
